<template>
    <div class="home-region study">
        <div class="region-cont">
            <div class="tit tit-gray">学习专区 <div class="tit-bottom"></div></div>
            <div class="study-list">
                <ul class="list-nav">
                    <li class="list" v-for="(item,index) in studyList" :key="index">
                        <a @click="study_click(item,index)" :class="item.isClick?'avtive':''" @mouseenter="study_move(item)" @mouseleave="study_shift(item)">
                            <div class="nav-cont">
                                <p class="nav-tit">{{item.tit}}</p>
                                <p class="nav-txt">{{item.txt}}</p>
                            </div>
                            <div class="nav-icon">
                                <img  width="100%" :src="item.mouseenter?item.imgHover:item.img" alt="">
                            </div>
                        </a>
                    </li>
                </ul>
                
                <div class="list-info"> 
                    <ancientBooks v-show="studyIndex==0"></ancientBooks>
                    <listInfo v-show="studyIndex==1" mode="clinic"></listInfo>
                    <listInfo v-show="studyIndex==2" mode="tcm"></listInfo>
                    <listInfo v-show="studyIndex==3"  mode="topic"></listInfo> 
                </div>
                
            </div>
        </div>
    </div> 
</template>

<script>
import homeData from '../homeData.js';
import ancientBooks from './study/ancientBooks.vue'
// 学临床和学中药的列表组件
import listInfo from './study/listInfo.vue'
export default {
    components:{
        ancientBooks,
        listInfo,
    },
    data () {
        return {
            studyList:homeData.studyList,
            studyIndex:0
        }
    },
    methods: {
        study_move(item) { 
			item.mouseenter = true
		},
        study_shift (item) { 
            if(item.isClick) return
			item.mouseenter = false
		},
        //切换右侧分类
        study_click(item,index){
            this.studyList.forEach(item => {
                item.isClick=false;
                item.mouseenter = false
            });
            item.isClick=true;
            item.mouseenter = true;
            this.studyIndex=index;
        },
    }
}
</script>

<style lang="less" scoped>
 // 学习专区
.study{ 
    min-width: 1200px;
    background: url('../../../assets/images/home/gray-page.png') no-repeat center;
    background-size: cover;
    .study-list{
        display: flex;
        justify-content: space-between;
        .list-nav{ 
            .list{
                width: 470px;
                height: 130px;//110px;
                margin-bottom:24px;// 10px;
                cursor: pointer;
                a{ 
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #FFFFFF;
                    border-radius: 12px;   
                    padding:0 20px ;
                    border: 1px solid #FFFFFF;
                    color: #5A6779;
                    &:hover,&.avtive{ 
                        background: #F1F5FE url('../../../assets/images/home/study-list-icon.png') no-repeat right center; 
                        border: 1px solid #386DE8;
                        color: #386DE8 ;
                        .list-btn{
                            border: 1px solid #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #fff;
                            .look-icon{
                                margin-left: 4px;
                                display: block;
                                width: 14px;
                                height: 6px;
                                background: url('../../../assets/images/home/look-icon.png') no-repeat;
                                background-size: contain;
                            }
                        }
                    }
                    .nav-cont{
                        width: 300px;
                        .nav-tit{ 
                            font-weight: bold;
                            font-size: 18px;
                            line-height: 36px;
                            // margin-bottom: 10px;
                        }
                        .nav-txt{
                            height: 48px;
                            line-height: 24px;
                            font-size: 14px;
                        }
                    }
                    .nav-icon{
                        width: 80px;
                    }
                }
            }
            
        }
    }
    .txt-clamp2{
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        display: -webkit-box;
        -webkit-line-clamp: 2;//（文字行数）;;
        -webkit-box-orient: vertical;
    }
}
</style>